import { Button, Modal } from "pepsico-ds";
import "./_segment-dialog-modal.scss";

const SegmentDialogModals = ({
  open,
  handleClose,
  action,
  segmentData,
  handleModalAction,
  loading = false,
}) => {
  const dialogText = {
    delete_segment: {
      title: "Delete segment?",
      description: (
        <div>
          <p>
            {`Are you sure you want to delete ${segmentData?.name || ""}? This action cannot be undone.`}
          </p>
        </div>
      ),
      button: "Delete",
    },
  };

  if (!action) return <></>;

  return (
    <>
      <Modal
        className="segment-dialog-modal"
        showModal={open}
        title={dialogText[action].title}
        text=""
        showTertiaryButton={false}
        showLink={false}
        showSecondaryButton={false}
        showPrimaryButton={false}
        onCloseModal={handleClose}
      >
        <div className="dialog-content">
          <>
            <div className="dialog-text">
              <div className="font-lg font-bold">{dialogText[action].title}</div>
              {dialogText[action].description}
            </div>
            <div className="dialog-buttons">
              <Button
                size="medium"
                variant="secondary"
                text="Cancel"
                onClick={handleClose}
              />
              <Button
                size="medium"
                text={dialogText[action].button}
                onClick={handleModalAction}
                isLoading={loading}
                disabled={loading}
              />
            </div>
          </>
        </div>
      </Modal>
    </>
  );
};

export default SegmentDialogModals;
